import PropTypes from 'prop-types'
import { PureComponent } from 'react'

import styles from './index.css'

class BackgroundCurve extends PureComponent {
  render() {
    return (
      <div className={this.props.className}>
        <svg
          className={styles.curve}
          enableBackground="new 0 0 1440 68"
          viewBox="0 0 1440 68"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="m1622.3 1937.7c0 0-410.7 169.1-913.4 75.5-502.7-93.6-977.7 56.3-977.7 56.3v440h1891.1v-571.8"
            fill="#F4F5F7"
            transform="translate(0-1977)"
          />
        </svg>
      </div>
    )
  }
}

BackgroundCurve.propTypes = {
  className: PropTypes.string,
}

BackgroundCurve.defaultProps = {
  className: null,
}

export default BackgroundCurve
